<template>
	<div class="page" @scroll="getScrollTop" ref="outerDom">
		<div @click="goBack" class="el-backtop" v-show="isShowBack"
			style="right: 40px; bottom: 40px;border: 1px solid #0056E2;">
			<i class="el-icon-caret-top"></i>
		</div>
		<!-- ------------------框架顶部------------------ -->
		<!-- 是否显示登录栏 -->
		<!-- <div class="flex-row justify-between align-center topBox">
			<img class="logobg" src="@/assets/index/logobg.png" />
			
			
			<div class="flex-row align-center justify-end">
			 
				<el-select v-model="value_transaction" placeholder="我的业务" v-if="isLogin"
					@change="$store.state.userName ? selchange($event) : setMyInfo()">
					<el-option v-for="item in options_transaction" :key="item.value"
						:label="item.value == 2 ? item.label + ' ' + $store.state.notificationCount : item.label"
						:value="item.value">
					</el-option>
				</el-select>

				<i class="el-icon-message-solid" v-if="!$store.state.notificationCount && isLogin" @click="gotoMsg"
					style="font-size: 1.5rem;color: #999999;cursor: pointer;margin-left: 1.5rem;"></i>
				<div class="messge-box" v-if="$store.state.notificationCount && isLogin" @click="gotoMsg">
					<i class="el-icon-message-solid"
						style="font-size: 1.5rem;color: red;cursor: pointer;margin-left: 1.5rem;"></i>
				</div>
				<i class="el-icon-chat-line-round" v-if="isLogin" @click="gotoImList"
					style="font-size: 1.5rem;color: #999999;cursor: pointer;margin-left: 1.5rem;"></i>
 
				<div class="flex-row align-center isLogin_btn" v-if="isLogin"
					@click="$store.state.userName ? personalCenter() : setMyInfo()">
					<img style="cursor: pointer" v-if="$store.state.userImg"
						:src="$store.state.userImg.indexOf('http') > -1 ? $store.state.userImg : uploadImgAddress + $store.state.userImg"
						alt="" />
					<span v-else class="noUserImg"></span>

					<div v-if="$store.state.userType == 3"
						style="display: flex;flex-direction: column;justify-content: center;cursor: pointer;align-items: flex-start;width:auto;background:none">
						<h4>{{$store.state.userName}}</h4>
						<p style="font-size: 0.875rem;color: #999; margin-top: 0.5rem;cursor: pointer;">{{$store.state.companyName}}</p>
					</div>
					<h4 v-if="$store.state.userType == 2">{{$store.state.userName}}</h4>
					<span style="cursor: pointer;margin-left: 20px;" @click.stop="tuichu">退出</span>
				</div>
				<div class="flex-row align-center isLogin_btn" v-else>
					<span :class="false ? 'btn_active' : '' " @click="loginHandle('/login')">登录</span>
					<el-divider direction="vertical"></el-divider>
					<span style="cursor: pointer;" @click="loginHandle('/register')">注册</span>
				</div>
			</div>
		</div> -->



		<!-- 导航栏 -->
		<navigation ref="navigationBar" />
		<!-- 主页面框架 -->
		<div class="main-container">
			<app-main />
		</div>
		<!-- 页面底部 -->
		<foot />
	</div>
</template>
<script>
	import AppMain from './components/AppMain.vue';
	import foot from './components/foot.vue';
	import navigation from './components/navigation.vue';
	import {
		GetUserNotificationCount
	} from "@/api/common";
	export default {
		name: "Layout",
		components: {
			AppMain,
			foot,
			navigation
		},
		props: {
			msg: String,
		},
		watch: {
			$route: function() {
				if (this.$route.path.indexOf('personalCenter') > -1 || this.$route.path.indexOf('enterpriseCenter') > -
					1) {
					sessionStorage.setItem('activeIndex', 99);
				} else if (this.$route.path == '/home') {
					sessionStorage.setItem('activeIndex', 0)
					this.value_transaction = '';
				} else {
					this.value_transaction = '';
				}
			}
		},
		computed: {
			userInfo() {
				// return JSON.parse(localStorage.getItem('userInfo'))
				return this.$store.state.userName
			},
		},
		data() {
			return {
				isLogin: false, //是否已登录
				options_transaction: [{
						value: '0',
						label: '个人中心',
						path: '/personalCenter'
					}, {
						value: '1',
						label: '在线简历',
						path: '/personalCenter/curriculumVitae'
					},
					// {
					// 	value: '2',
					// 	label: '消息',
					// 	path: '/personalCenter/message'
					// },
				],
				value_transaction: '',
				// notificationCount: '', // 消息数量

				activeIndex: sessionStorage.getItem('activeIndex'), // 当前激活的页面index

				uploadImgAddress: process.env.VUE_APP_URL_IMG, // 图片显示路径
				show_masking: this.$store.state.show_masking,
				isShowBack: false,
				scrollTrigger: false, //默认初始值
				 scrollTop: 0, //默认距离顶部的距离
			};
		},
		created() {
			// this.value_transaction = '';
			var obj = localStorage.getItem('userInfo');
			if (obj) {
				let identity = localStorage.getItem('identity');
				if (identity == 3) this.options_transaction = [{
						value: '0',
						label: '企业中心',
						path: '/enterpriseCenter'
					}, {
						value: '1',
						label: '我要招聘',
						path: '/enterpriseCenter/publish'
					},
					// {
					// 	value: '2',
					// 	label: '消息',
					// 	path: '/enterpriseCenter/message'
					// },
				];

				let userObj = JSON.parse(obj);
				this.$store.commit('SET_USERNAME', userObj.name);
				this.$store.commit('SET_USERTYPE', userObj.userType);
				this.$store.commit('SET_COMPANYNAME', userObj.companyName);
				this.$store.commit('SET_USERIMG', userObj.userImg ? userObj.userImg : userObj.userImage);
			}
		},
		mounted() {
			// this.changeRoute()
			if (localStorage.getItem("sessionToken")) {
				this.isLogin = true;
				let type = localStorage.getItem('identity') == 2 ? 1 : 2; // 1个人消息 2企业消息
				this.getUserNotificationCount(type);
			} else {
				this.isLogin = false
			}

		},
		methods: {
			goBack() {
				let that = this; // 防止this指向问题
				// 防止频繁点击，故返回顶部后设置scrollTrigger为初始值
				if (that.scrollTrigger) {
					return;
				}
				// 获取当前距离顶部的距离
				let scrollTop = this.scrollTop; 
				let steep = scrollTop / 2000;
				let timer = setInterval(() => {
					that.scrollTrigger = true;
					// 滚动的速度逐渐变快，第一次走2000/1，然后减去已走的距离，下一次用剩下的距离再减去步进值，步进值也是不断变化，这样速度会越来越快
					scrollTop -= steep;
					// 步进值不改变的话会匀速缓慢上滑，不断增加步进值上滑的距离增加，视觉效果速度变快
					steep += 20;
					if (scrollTop <= 0) {
						clearInterval(timer);
						that.scrollTrigger = false;
					}
					that.$refs.outerDom.scrollTop = scrollTop;
				}, 20);
			},
			// 监听滚动条
			getScrollTop(e) {
				let that = this; // 防止this指向问题
				// 设备一屏的高度
				let clientHeight =
					document.documentElement.clientHeight || document.body.clientHeight;
				let scrollTop = e.srcElement.scrollTop;
				this.scrollTop = scrollTop;
				// 判断距离顶部多少显示回到顶部图标
				if (scrollTop > clientHeight) {
					that.isShowBack = true;
				} else {
					that.isShowBack = false;
				}
			},
			//跳转聊天列表
			gotoImList() {
				let identity = localStorage.getItem('identity');
				let path = '';
				let query = {}
				if (identity == 2) {
					path = "/personalCenter/onlineCommunication/0"
				} else {
					path = "/enterpriseCenter/communicate";
					query = {
						type: 2,
						status: 1
					}
				}
				this.$router.push({
					path: path,
					query: query
				}, () => {})
			},
			//跳转消息页面
			gotoMsg() {
				let path = ''
				let identity = localStorage.getItem('identity');
				if (identity == 2) {
					path = "/personalCenter/message"
				} else {
					path = "/enterpriseCenter/message";
				}
				this.$router.push({
					path: path,
					query: {
						type: 99
					}
				}, () => {})
			},
			// 顶部业务下拉选择框
			selchange(val) {
				console.log(this.options_transaction[val].path)
				if (!localStorage.getItem("sessionToken")) {
					this.$message.warning('您还未登录！');
					return;
				}
				// 区别登录用户身份
				// let path = localStorage.getItem('identity') == 2 ? '/personalCenter' : '/enterpriseCenter';
				if (val == 2) {
					this.$router.push({
						path: this.options_transaction[val].path,
						query: {
							type: 99
						}
					}, () => {})
				} else {
					this.$router.push({
						path: this.options_transaction[val].path
					}, () => {})
				}
			},
			// 获取消息数量
			getUserNotificationCount(type) {
				GetUserNotificationCount({
					model: {
						type: type // 1个人消息 2企业消息
					}
				}).then(res => {
					this.$store.commit('SET_NOTIFICATIONCOUNT', res.count)
				})
			},

			// 个人信息未完善强制完善，跳转个人信息完善页面
			setMyInfo() {
				this.$router.push({
					path: '/login_myinfo',
					query: {
						identity: JSON.parse(localStorage.getItem('identity')) // 2个人， 3企业,
						// isSkip : res.isSkip // 用isSkip判断跳转简历维护或者是企业信息页面
					}
				}, () => {});

				this.$message.warning('请先完善个人信息！');
			},

			//个人中心
			personalCenter() {
				// 区别登录用户身份
				let path = localStorage.getItem('identity') == 2 ? '/personalCenter' : '/enterpriseCenter'
				this.$router.push({
					path: path,
				}, () => {})
			},
			//退出
			tuichu() {
				this.$confirm('确定退出?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					localStorage.clear();
					sessionStorage.clear();
					this.$refs.navigationBar.initOP()
					this.isLogin = false
					this.$router.push({
						path: '/',
					}, () => {})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消退出'
					});
				});
			},
			//跳转至登录、注册页
			loginHandle(path) {
				this.$router.push({
					path: path,
					query: {
						id: this.$route.query.id,
						redirect: path == '/login' ? this.$route.path : '',
						type: this.$route.query.type ? this.$route.query.type : 0,
					}
				}, () => {})
			},
			changeRoute() {
				// if (this.$route.path == '/productionEntity'){
				//     this.textActive = 'productionEntity'
				// } else if(this.$route.path == '/productionGuidance') {
				//   this.textActive = 'productionGuidance'
				// } else if (this.$route.path == '/agriculturalDetection'){
				//   this.textActive = 'agriculturalDetection'
				// } else if (this.$route.path == '/remoteControl'){
				//   this.textActive = 'remoteControl'
				// } else if (this.$route.path == '/digitalProduction'){
				//   this.textActive = 'digitalProduction'
				// }
			}
		}
	};
</script>

<style scoped lang="scss">
	@import "~@/styles/index.scss";

	@keyframes twinkle {
		from {
			opacity: 1.0;
		}

		50% {
			opacity: 0.4;
		}

		to {
			opacity: 1.0;
		}
	}

	::v-deep .messge-box .el-icon-message-solid {
		animation: twinkle 1s;
		animation-iteration-count: infinite;
	}

	.page {
		width: 100vw;
		height: 100vh;
		overflow: auto;
		background-color: $color-bg;

		.topBox {
			width: 100%;
			height: 106px;
			background: #fff;
			padding: 0 $padding-both;

			span {
				cursor: pointer;
			}

			::v-deep .el-select {
				display: inline-block;
				position: relative;
				width: 141px;
				height: 40px;
				border-radius: 20px;

				.el-input__inner {
					// -webkit-appearance: none;
					background-color: #FFF;
					background-image: none;
					/* box-sizing: border-box; */
					color: #606266;
					display: inline-block;
					line-height: 40px;
					outline: 0;
					padding: 0 15px;
					transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
					width: 100%;
					height: 40px;
					border: 1px solid #999999;
					border-radius: 20px;
				}
			}

			.logobg {
				//width: 360px;
				height: 89px;
			}

			.isLogin_btn {
				margin-left: 40px;

				img,
				.noUserImg {
					width: 56px;
					height: 56px;
					margin-right: 10px;
					border-radius: 50%;
					border: #E5E5E5 1px solid;
					background: #E5E5E5;
				}

				div {
					width: 1px;
					height: 14px;
					line-height: 14px;
					background: #333;
					margin: 0 5px;
				}

				span {
					font-size: 16px;
					font-family: PingFang SC;
					font-weight: 400;
					color: #333;

					&:hover {
						color: #008DD6;
					}
				}

				.el-divider--vertical {
					transform: rotate3d(1, 1, 1, 45deg);
					color: #333;
				}

				.btn_active {
					color: #04CC89;
				}

				.el-icon-user-solid {
					font-size: 16px !important;
				}
			}
		}

		.main-container {
			width: 100%;
			height: auto;
			background-color: $color-bg;
			// overflow: scroll;
		}

	}
</style>